import { fromJS } from 'immutable';
import * as types from '../constants';
import LocalStorageUtility from '../common/localStorageUtility/localStorageUtility';

const initialState = fromJS({
  yesterday: {},
  tomorrow: {},
  today: {},
});

/*function emptyCompetitions(competitions) {
  for (const competition of competitions) {
    if (competition.competitionMatches.length) {
      return competitions;
    }
  }
  return [];
}*/

function updateFavouritesMatch(filteredCompetitions) {
  const newMap = filteredCompetitions;
  const preferredMap = LocalStorageUtility.getPreferredMatch();
  if (preferredMap && Object.keys(preferredMap).length) {
    Object.keys(newMap).forEach((key) => {
      if (newMap[key] && newMap[key].length) {
        newMap[key].forEach((competition) => {
          competition.competitionMatches = competition.competitionMatches.map((match) => {
            if (preferredMap[match.matchId] || preferredMap[match.id]) {
              match.favourite = true;
            } else {
              match.favourite = false;
            }
            return match;
          }).filter(match => match.favourite);
        });
      }
    });
    return newMap;//.filter(el => (el.competitionMatches.length > 0));
  } else return {};
}
function updateFavouritesMatchToday(filteredCompetitions) {
  const newMap = filteredCompetitions;
  const preferredMap = LocalStorageUtility.getPreferredMatch();
  if (newMap.length) {
    newMap.forEach((competition) => {
      competition.competitionMatches = competition.competitionMatches.map((match) => {
        if (preferredMap[match.matchId] || preferredMap[match.id]) {
          match.favourite = true;
        } else {
          match.favourite = false;
        }
        return match;
      }).filter(match => match.favourite);
      //competition.competitionMatches = competition.competitionMatches.
    });
  }
  return newMap.filter(el => (el.competitionMatches.length > 0));
}


export default function favouritesReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_YESTERDAY_SPORT:
      return state.set('yesterday', fromJS(updateFavouritesMatch(action.yesterday)));
    case types.SET_TOMORROW_SPORT:
      return state.set('tomorrow', fromJS(updateFavouritesMatch(action.tomorrow)));
    case types.SET_TODAY_SPORT:
      return state.setIn(['today', action.sportId], fromJS(updateFavouritesMatchToday(action.data)));
    case types.UPDATE_FAVOURITES:
      switch (action.date) {
        case 'today':
          if (!LocalStorageUtility.getTodaySportIds().length) {
            return state.deleteIn(['today', action.sportId]);
          } else {
            return state.setIn(['today', action.sportId], fromJS(updateFavouritesMatchToday(state.getIn(['today', action.sportId]).toJS())));
          }
        case 'yesterday':
          if (!LocalStorageUtility.getYesterdaySportIds().length) {
            return state.deleteIn(['yesterday', action.sportId]);
          } else {
            return state.set('yesterday', fromJS(updateFavouritesMatch(state.get('yesterday').toJS())));
          }
        case 'tomorrow':
          if (!LocalStorageUtility.getTomorrowSportIds().length) {
            return state.deleteIn(['tomorrow', action.sportId]);
          } else {
            return state.set('tomorrow', fromJS(updateFavouritesMatch(state.get('tomorrow').toJS())));
          }
        default:
          return state;
      }
    default:
      return state;
  }
}
